import { createGqlQuery } from '../fetcher';
import { IncidentCategories } from '../queries/incidentCategories.query';
import type * as Types from '../types';

export const useIncidentCategoriesQuery = createGqlQuery<
  Types.IncidentCategoriesQueryVariables,
  Types.IncidentCategoriesQuery
>((variables) => ['incidentCategories', variables], IncidentCategories);
